//import { Component } from '@angular/core';
import { App, NavController, NavParams,LoadingController, ToastController, Events } from 'ionic-angular';
import { HomePage } from '../home/home';
import { PostPicPage } from '../post-pic/post-pic';
import { CommentViewPage } from '../comments-view/comments-view';
import { VoteBankPage } from '../vote-bank/vote-bank';
import { UserPostPage } from '../user-posts/user-posts';
import { ApiService } from '../../api-service/api-service';
import { SocialSharing } from '@ionic-native/social-sharing';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

import { Component, ViewChild } from '@angular/core';
import { updateImgs } from 'ionic-angular/components/content/content';
import { Img } from 'ionic-angular/components/img/img-interface';
import { Content } from 'ionic-angular';

import { User,UserPost,UserComment,UserData,Ladder } from '../../providers/providers';
import { dateDataSortValue } from 'ionic-angular/util/datetime-util';

declare var AWS: any;
declare const aws_user_files_s3_bucket;
declare const aws_user_files_s3_bucket_region;

const url = 'https://cdn.chitika.net/getads.js';

@Component({
  selector: 'page-category',
  templateUrl: 'category.html'
})
export class CategoryPage {

  loadAPI: Promise<any>;
  public postPicPage = PostPicPage;
  public commentViewPage = CommentViewPage;
  public voteBankPage = VoteBankPage;
  public userPostPage = UserPostPage;
  public category:Ladder = new Ladder();
  public changedCategory:Ladder;
  items:UserPost[] = [];
  itemSort:UserPost[] = [];
  amazonAd:boolean = false;

  private s3: any;
  public sub: string = null;
  public lastKey: any;
  public IScroll:any;
  public ladders:Ladder[] = [];
  public lastVoteDate:string;

  public timeLeft:number = 60;
  public days:number
  public hours:number;
  public minutes:number;
  public seconds:number;
  private timerStarted:boolean = false;
  public userName:string;
  public placement_id:number;
  public bannerId:string = "not set";

  sharePost: UserPost;

  constructor(public navCtrl: NavController,public navParams:NavParams,public server:ApiService,
    public user:User,
    //private transfer: FileTransfer,
    public toastCtrl: ToastController, public userData:UserData, public events:Events, public socialShare:SocialSharing,
    private googleAnalytics: GoogleAnalytics) {
      
      this.s3 = new AWS.S3({
        'params': {
          'Bucket': aws_user_files_s3_bucket
        },
        'region': aws_user_files_s3_bucket_region
      });
      this.category = new Ladder();

      if (navParams.get('category')){
        this.category = navParams.get('category');
      }
      this.userName = this.user.getUsername();

      //this.userData.refreshUserData();

      this.server.getCategories(this.getCategoryCallBack);

      this.google();
      //this.chitikaAddHeight();

  }

  ngOnInit(){
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        this.loadScript(url);
    });
}

public loadScript(url:string, useChitika:boolean=true, chitikaName:string=null) {
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    if(useChitika){
      if(chitikaName){
        this.chitikaAddHeight(chitikaName,550,250);
      }
      else
      {
      this.chitikaAddHeight();
      }
    }
}

  google(){
    this.googleAnalytics.startTrackerWithId('UA-121637538-1', 30)
   .then(() => {
     console.log('Google analytics is ready now');
        this.googleAnalytics.trackView('Screen Title')
        .then(()=>{
          console.log('Success');
        })
        .catch((e)=>{
          console.log("Faild"+ e)
        })

        this.googleAnalytics.trackView('Screen Title', 'my-scheme://content/1111?utm_source=google&utm_campaign=my-campaign')
        .then(()=>{
          console.log("Success 1")
        })
        .catch((e)=>{
          console.log("Faild 1" + e)
        })

        this.googleAnalytics.trackEvent('Category', 'Action', 'Label', 30)
        .then(()=>{
          console.log("Success Event");
        })
        .catch(()=>{
          console.log("Faild")
        })

        this.googleAnalytics.trackMetric(5)
        .then(()=>{
          console.log("Key Matrics run successfully");
        })
        .catch((e)=>{
          console.log("Faild" + e)
        })

        this.googleAnalytics.trackTiming('Category', 2, 'Variable', 'Label')
        .then(()=>{
          console.log("TrackTiming success")
        })
        .catch((e)=>{
          console.log("Faild"+ e)
        })
     // Tracker is ready
     // You can now track pages or set additional information such as AppVersion or UserId
     this.googleAnalytics.debugMode();
     this.googleAnalytics.setAllowIDFACollection(true);
   })
   .catch(e => console.log('Error starting GoogleAnalytics', e));
  }

  avatarUpdatedCallback= (data) => {
    this.avatarUpdated(data);
  }

  avatarUpdated(data){
    let test = data;
  }

  

  /* 2017-08-16 - add this to class body
    start FIX#9660 ion-img doesn't correctly work with virtualScroll
    https://github.com/ionic-team/ionic/issues/9660#issuecomment-304840427
*/
@ViewChild(Content) _content: Content;
ngAfterViewInit() {
    if (this._content) {
        this._content.imgsUpdate = () => {
            if (this._content._scroll.initialized && this._content._imgs.length && this._content.isImgsUpdatable()) {
                // reset cached bounds
                this._content._imgs.forEach((img: Img) => (<any>img)._rect = null);
                // use global position to calculate if an img is in the viewable area
                updateImgs(this._content._imgs, this._content._cTop * -1, this._content.contentHeight, this._content.directionY, 1400, 400);
            }
        };
    }
}
/*
end FIX#9660
*/

  /*comments(postId){
    let testComment = new UserComment(postId);
    //let testComment = new UserComment(postId,this.user.getUsername());
    //this.server.postComment(testComment);
  }
*/
  addPost(){
    
    let newPost = new UserPost(this.category.Category);
    this.navCtrl.push(this.postPicPage,{userPost:newPost});
  }

  checkGenerator(){
    this.navCtrl.push(this.voteBankPage);
  }

  comments(postId){
    this.navCtrl.push(this.commentViewPage,{userPostId:postId});
  }

  getUserLadder(userLadderName:string,avatarLadderURL:string){
    //alert(userLadderName+" : "+avatarLadderURL);
    this.navCtrl.push(this.userPostPage, {userName:userLadderName, userAvatar:avatarLadderURL});
  }

  ladderSelected(event){
    if(event === this.changedCategory)
    {
      //error in framework workaround
      return;
    }
    this.amazonAd = false;
    this.items = [];
    this.category = this.setLadder(event);
    this.changedCategory = this.category;
    this.getCategoryCountdown(this.category.VoteEnding);
    this.setLastCategoryDate();
    this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    this.events.subscribe("PostAdded:"+this.category.Category, (postEventData) =>{
      this.items = [];
      this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    });
  }


  countDownSecond(){
    this.seconds -= 1;
    let tickMinute = false;
    let tickHour = false;
    let tickDay = false;
    if(this.days ===0 && this.hours === 0 && this.minutes === 0 && this.seconds === 0){
        //TODO reset timer  
      //this.server.checkVoteGenerator();
    }

    if(this.seconds === 0){
       tickMinute = true;
       this.seconds = 59;
    }
    if(tickMinute === true){
      if(this.minutes === 0){
        this.minutes = 59;
        tickHour = true;
      }
      else{
      this.minutes -= 1
      }
      tickMinute = false;
    }
    if(tickHour === true ){
      if(this.hours === 0){
        this.hours = 23;
        tickDay = true;
      }
      else
      {
        this.hours -= 1;
      }
      tickHour = false;
    }
    if(tickDay === true){
      this.days -= 1;
      tickDay = false;
    }

    //if(this.hours < 0){
    //  this.server.checkVoteGenerator(this.checkBankCallBack);
    // }
  }

  private StartTimerCountdown() {
    this.timerStarted = true;
    return setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft -= 1;
        this.countDownSecond();
      }
      else {
        this.server.getCategories(this.getCategoryCallBack);;
      }
    }, 1000);
  }

  getCategoryCountdown(categoryResetDate:string){
    let resetDate = new Date(categoryResetDate);
    resetDate.setUTCHours(resetDate.getUTCHours());
    let currentTimeISO = new Date().toISOString();
    let currentTime = new Date(currentTimeISO);
    this.timeLeft = ( resetDate.getTime() - currentTime.getTime()) / 1000;

    //let seocondsDate = new Date(null);
    //seocondsDate.setSeconds(this.timeLeft);
    let workingSeconds = this.timeLeft;
    this.days = Math.floor(workingSeconds / 60 / 60 / 24);
    let daysHoursMins = this.days * 60 * 60 * 24;
    workingSeconds = workingSeconds - daysHoursMins;

    this.hours = Math.floor(workingSeconds / 60 / 60);
    let hoursMins = this.hours * 60 * 60;
    workingSeconds = workingSeconds - hoursMins;
    if(workingSeconds > 60)
    {
      this.minutes = Math.floor(workingSeconds / 60);
    }
    else
    {
      this.minutes = 0;
    }
    let minsSeconds = this.minutes * 60;
    workingSeconds = Math.floor(workingSeconds - minsSeconds);
    this.seconds = workingSeconds;

    if(!this.timerStarted){
      var timer = this.StartTimerCountdown();
    }
    
  }

  public setLadder(selectedCategory){
    for(let i=0;i<this.ladders.length;i++){
      if(this.ladders[i].Category === selectedCategory.Category){
        return this.ladders[i];
      }
    }

  }
  
  generateTestPosts(){
    for (let i = 0; i < 30; i++) {
        let fakePost = new UserPost("Funny");
        fakePost.generateTestPost();
        this.items.push( fakePost );
        }
    }

      //Fat arrow used to keep scope, private entry back in
  public getPostsCallBack = (posts) => {
    this.getPosts(posts);
  }
  getPosts(userPosts){

    if(!this.userData.avatarKey){
      let subId = AWS.config.credentials.identityId;
      let avatarKey = 'protected/' + subId + '/avatar';
      this.server.updateUserData(this.userData.avatarKey, this.avatarUpdatedCallback);

      //  this.generateTestPosts();
      //this.server.getCategories(this.getCategoryCallBack);
    }

    if(userPosts.LastEvaluatedKey){
      this.lastKey = userPosts.LastEvaluatedKey;
    }
    else
    {
      this.lastKey = "";
    }
    //userPosts.Items.sort((leftSide,rightSide):number=> {
    //  if(leftSide.postTimeStamp < rightSide.postTimeStamp) return -1;
    //  if(leftSide.postTimeStamp > rightSide.postTimeStamp) return 1;
    //  return 0;
    //});



    this.itemSort = [];
    for (let i = 0; i < userPosts.Items.length; i++) {
      this.s3.getSignedUrl('getObject', {'Key': userPosts.Items[i].picKey}, (err, url) => {
        userPosts.Items[i].picURL = url;
        //this.items.push( userPosts[i] );
        this.s3.getSignedUrl('getObject', {'Key': userPosts.Items[i].avatarKey}, (err, avatarUrl) => {
          userPosts.Items[i].avatarURL = avatarUrl;
          //this.items.push( userPosts.Items[i] );
          this.itemSort.push( userPosts.Items[i]);
          if(this.itemSort.length === userPosts.Items.length)
          {

            this.updatePostList();
          }
        });
      });

      //this.setLastCategoryDate();

        //this.items.push( userPosts[i] );
        }
        if(this.IScroll){
          this.IScroll.complete();
        }


    }

    getAmazonCode(){
      let code = "amzn-assoc-ad-83c4a0ab-7746-4660-b07f-31dc55e3e31b";
      let src = "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=83c4a0ab-7746-4660-b07f-31dc55e3e31b";
      if(this.category.Category === "Pets"){
        code = "amzn-assoc-ad-5a080e6c-236a-4981-ad1b-99ca4433f7f6";
        src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=5a080e6c-236a-4981-ad1b-99ca4433f7f6";
      }
      if(this.category.Category === "Funny"){
        code = "amzn-assoc-ad-0c0e9921-a2e2-4d40-9f56-7152fdd3b9f1";
        src = "//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=0c0e9921-a2e2-4d40-9f56-7152fdd3b9f1";
      }
      let codeSrc = {
        "code":code,
        "src":src
      }
      return codeSrc;
    }
  
    public updatePostList(){

      if (this.amazonAd === false){
      let adPost = new UserPost(this.category.Category);
      adPost.message = "PROMOTED";
      let srcCode = this.getAmazonCode();
      adPost.userName = srcCode.code;
      adPost.postDate = "2016-07-03T19:15:10.176Z"
      adPost.postTimeStamp = 1500645394813
      //adPost.postDate = ""
      this.itemSort.push(adPost);
      //let src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=5a080e6c-236a-4981-ad1b-99ca4433f7f6";
      this.loadScript(srcCode.src,false);
      this.amazonAd = true;
    }
    else{
      let adPost = new UserPost(this.category.Category);
      adPost.message = "PROMOTED";
      let placement_id = window['CHITIKA'].units.length;
      let bannerId = "chitikaAdBlock-"+placement_id.toString();
      adPost.userName = bannerId;
      adPost.postDate = "2016-07-03T19:15:10.176Z"
      adPost.postTimeStamp = 1500645394813
      //adPost.postDate = ""
      this.itemSort.push(adPost);
      //let src="//z-na.amazon-adsystem.com/widgets/onejs?MarketPlace=US&adInstanceId=5a080e6c-236a-4981-ad1b-99ca4433f7f6";
      this.loadScript(url,true, bannerId);
    }


      this.itemSort.sort((leftSide,rightSide):number=> {
      if(leftSide.postTimeStamp > rightSide.postTimeStamp) return -1;
      if(leftSide.postTimeStamp < rightSide.postTimeStamp) return 1;
      return 0;
    });
      for (let i=0; i<this.itemSort.length; i++){
        this.items.push(this.itemSort[i]);
      }
      //this.setLastCategoryDate();
    }
    
    public setLastCategoryDate = () => {
      this.setMyLastCategoryDate();
    }
    
    public setMyLastCategoryDate(){

      //if(this.category.getVoteStartDate())
      {
        //this.lastVoteDate = this.category.VoteEnding;
        this.lastVoteDate = this.getVoteStartDate(this.category.VoteEnding);
      }
    }

    public getVoteStartDate(voteEnding){
      let workingDate = this.parseISOString(voteEnding);
      let days = -7;
      workingDate.setTime(workingDate.getTime() + (days * 86400000));
      return workingDate.toISOString();
  }

  parseISOString(s) {
      var b = s.split(/\D+/);
      return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  public getDayNumber(dayEnding){
    if(dayEnding === "SUN"){
      return 0;
    }
    if(dayEnding === "MON"){
      return 1;
    }
    if(dayEnding === "TUE"){
      return 2;
    }
    if(dayEnding === "WED"){
      return 3;
    }
    if(dayEnding === "THU"){
      return 4;
    }
    if(dayEnding === "FRI"){
      return 5;
    }
    if(dayEnding === "SAT"){
      return 6;
    }
  }

  public getCategoryCallBack = (allLadders) => {
    this.getCategory(allLadders);
  }
  getCategory(allLadders){
    for (let i = 0; i < allLadders.length; i++) {
      this.ladders.push( allLadders[i] );
    }
    //this.setLastCategoryDate();
    //this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    
    //this.events.subscribe("PostAdded:"+this.category.Category, (postEventData) =>{
    //  this.server.getPics(this.category.Category,null,this.getPostsCallBack);
    //});
    this.ladderSelected(this.category);
  }
  
    voteForPost(Post){
      
      if(this.userData.votes > 0)
      {
        this.server.voteForPic(Post,this.voteForPostCallBack);
      }
      else
      {
        alert ("Out of Votes!  Check vote bank for more votes in upper right corner!");
      }
    }

    public voteForPostCallBack = (postsVotedOn:UserPost) => {
      this.updateVote(postsVotedOn);
    }

    updateVote(postsVotedOn:UserPost){
      postsVotedOn.votes = postsVotedOn.votes+1
      this.userData.votes = this.userData.votes - 1;  
    }

    
    public deletePost(postToDelete:UserPost){
      let deleteConfirm = confirm("delete post "+postToDelete.message.substr(0,50)+"?");
      if(deleteConfirm){
        this.server.deletePic(postToDelete,this.deletePostCallBack);
        //alert("implement delete!");
      }
    }

    public deletePostCallBack = (postDeleted:UserPost) => {
      this.postDeleted(postDeleted);
    }

    postDeleted(postDeleted:UserPost){
      for(let i = 0; i< this.items.length; i++){
        if(this.items[i].UserPostId === postDeleted.UserPostId){
            this.items.splice(i,1);
          break;
        }
      } 
    }

    regularShare(index:UserPost){
      this.sharePost = index;
      this.toDataUrl(this.sharePost.picURL,this.regularShareCallBack);
    }

    regularShareCallBack= (encodedPic) => {
      this.socalShare(encodedPic);
    }

    socalShare(encodedPic){
      var msg = this.sharePost.message;
      this.socialShare.share(msg, "Cool post from picladder.com", null, "http://picladder.com")
      .catch( (err) => {
        //alert('no share');
        //alert(err);

      });

    }

   toDataUrl(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function() {
          var reader = new FileReader();
          reader.onloadend = function() {
              callback(reader.result);
          }
          reader.readAsDataURL(xhr.response);
      };
      xhr.open('GET', url);
      xhr.responseType = 'blob';
      xhr.send();
      xhr.onerror = function(err){
        //alert('err');
        let test = err;
                
      }
  }

    
  doInfinite(infiniteScroll) {
    this.IScroll = infiniteScroll;
    console.log('Begin async operation');
    if (this.lastKey !== "")
    {
      this.server.getPics(this.category.Category,this.lastKey,this.getPostsCallBack);
    }
    else
    {
      //this.chitikaAddHeight();
      infiniteScroll.complete();
    }
    /*setTimeout(() => {
      for (let i = 0; i < 30; i++) {
          let fakePost = new UserPost("Funny");
          fakePost.generateTestPost();
        this.items.push( fakePost );
      }

      console.log('Async operation has ended');
      infiniteScroll.complete();
    }, 500);
    */
  }

  chitikaAddHeight(idName:string="",width:number=320,height:number=50){
    if (window['CHITIKA'] === undefined) {
      window['CHITIKA'] = { 'units' : [] };
    };
    if(idName === ""){
      var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
      this.placement_id = window['CHITIKA'].units.length;
      window['CHITIKA'].units.push(unit);
      this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
    }
    else
    {
      var unit1 = {"calltype":"async[2]","publisher":"picladder","width":width,"height":height,"sid":"Chitika Default"};
      window['CHITIKA'].units.push(unit1);
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/category/category.ts